import style from "./CorporateProfile.module.css";
import { Link } from "react-router-dom";
export default function Main() {
  return (
    <>
      <div className={style.mainbox}>
        <div className={style.infobox}>
          <h2>金茂担保有限公司</h2>
          <p>
            温州市金茂融资担保有限公司成立于2007年1月,注册资本金人民
            币1亿元,是经温州市经信委和浙江省中小企业局备案,获得中华
            人民共和国融资性担保机构经营许可证(证号浙0003024)的企
            业。被中国人民银行杭州中心支行和省经信委资信评级为A+,并经
            浙江省融资性担保业务监管联席会议办公室决定使用《浙江省融资
            性担保机构统一标识》单位之一。
          </p>
        </div>
        <Link className={style.more} to="/about">
          了解更多 →{" "}
        </Link>
      </div>
    </>
  );
}
